import {exhibitionMapConstants} from "../constants/exhibition-map.constants";

const initState = {
    roomsList: null,
    errorFormConfig: null
};

export function exhibitionMapReducer(state = initState, action) {
    switch (action.type) {
        case exhibitionMapConstants.ROOMS_LIST_REQUEST:
            return  {
                ...state,
                roomsList: null
            };
        case exhibitionMapConstants.ROOMS_LIST_SUCCESS:
            return {
                ...state,
                roomsList: action.rooms
            };
        case exhibitionMapConstants.MAP_CONFIG_CRUD_FAILURE:
            return  {
                ...state,
                errorFormConfig: action.error
            };
        case exhibitionMapConstants.ROOMS_LIST_CLEAR:
            return {
                ...state,
                roomsList: null
            };
        default:
            return state
    }
}
